module.exports = __webpack_public_path__ + "img/alert_fan_red.47085fe7.svg";